module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/lodash/entriesIn.js
// module id = 1074
// module chunks = 1